import {
  AudioModelType,
  axiosInstance,
  createFilteringSortingUrlParams,
  FilteringSortingParams,
} from '../../utils';
import { IAudioCreation } from '../../@types';

export interface GetAllCreatedAudiosResponse {
  data: IAudioCreation[];
  count: number;
}

export const getAllCreatedAudios = async (
  params: FilteringSortingParams,
  model?: AudioModelType,
  name?: string,
  genType?: string,
): Promise<GetAllCreatedAudiosResponse> => {
  const searchParams = createFilteringSortingUrlParams(params);
  if(model) {
    searchParams.append('model', model);
  }
  if(name) {
    searchParams.append('name', name);
  }
  if(genType) {
    searchParams.append('genType', genType);
  }
  const res = await axiosInstance.get(`/api/audios/get-build-audios?${searchParams.toString()}`);
  return res.data;
};
